import { render, staticRenderFns } from "./DelegationInfoVehicleView.vue?vue&type=template&id=218fcaf5&scoped=true&"
import script from "./DelegationInfoVehicleView.vue?vue&type=script&lang=js&"
export * from "./DelegationInfoVehicleView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218fcaf5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('218fcaf5')) {
      api.createRecord('218fcaf5', component.options)
    } else {
      api.reload('218fcaf5', component.options)
    }
    module.hot.accept("./DelegationInfoVehicleView.vue?vue&type=template&id=218fcaf5&scoped=true&", function () {
      api.rerender('218fcaf5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/delegation-info/DelegationInfoVehicleView.vue"
export default component.exports